import { render } from "./UpdateTax.vue?vue&type=template&id=7fb2c506"
import script from "./UpdateTax.vue?vue&type=script&lang=js"
export * from "./UpdateTax.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__